/**
 * HP-2214: extracted-inclusion entries flow through bedbank's unified
 * `inclusions[]` array discriminated by `source: 'supplier' | 'extracted'`.
 * Admin readers consume only the unified shape — bedbank still emits the
 * legacy `extraInclusions` field for backward-compat with other consumers,
 * but admin no longer reads it.
 */
type UnifiedInclusion = {
  text: string;
  icon: string | null;
  source?: string;
  code?: string;
};

export type ExtractedInclusion = {
  code: string;
  label: string;
};

export type ExtractedInclusionSource = {
  inclusions?: Array<UnifiedInclusion>;
};

export function getExtractedInclusions(source: ExtractedInclusionSource): Array<ExtractedInclusion> {
  return (source.inclusions ?? [])
    .filter(
      (inclusion): inclusion is UnifiedInclusion & { code: string } =>
        inclusion.source === 'extracted' && typeof inclusion.code === 'string' && inclusion.code.length > 0,
    )
    .map((inclusion) => ({ code: inclusion.code, label: inclusion.text }));
}
